module.exports = __webpack_public_path__ + "static/slider-1-9284af0053bbc7492c77f8730ef09209.png";